<template lang="pug" src="./custom-about-doctors.pug"></template>

<script>
export default {
  data () {
    return {
      activeTabs: [],
      activeTab: 0,
      activeDoctor: null
    }
  },
  props: ['props'],
  methods: {
    selectTab (i, j) {
      this.activeTabs[i].tab = j
    },
    onWaypointImage ({ going, direction, el }) {
      if (going === this.$waypointMap.GOING_IN) {
        el.nextSibling.classList.add('custom-about-doctors__image-mask--active')
        el.nextSibling.children[0].classList.add('custom-about-doctors__image--active')
      }
    }
  },
  async created () {
    this.props.doctors.forEach(() => {
      this.activeTabs.push({ tab: 0 })
    })
  }
}
</script>



// WEBPACK FOOTER //
// custom-about-doctors.vue?d5bef52c